<template>
  <div class="page cle" style="">
    <div class="page-prev fl">
      <div @click="prev"></div>
    </div>
    <div class="page-num fl" :class="{'page-now':items==nowPages,'point':items!=='...'}" v-for="(items,index) in allPages" :key="index" v-text="items" @click="setPage(items)"></div>
    <div class="page-next fl">
      <div @click="next"></div>
    </div>
    <div class="page-num fl">
      <input type="text" class="page-num-in" v-model="pageVal" v-on:keyup="pageIn" v-on:blur="pageBl">
    </div>
    <button type="button" class="page-btn fl" :title="confirmText" v-text="confirmText" @click="jump"></button>
  </div>
</template>
<script>
export default {
  name:'Page',
  props:['nowPage','allPage','showNum'],
  data(){
    return {
      nowPages:this.nowPage||1,
      showNums:this.showNum||10,
      allPages:[],
      showMax:8,
      confirmText:'',
      pageVal:1
    }
  },
  created:function(){
    this.allPages=this.setAll();
  },
  mounted:function(){
    this.confirmText=this.lanNow.lan['K024_Confirm'];
  },
  methods:{
    setPage:function(data){
      if(data==='···'){
        return false
      };
      if(data-0>this.allPage){
        return false
      };
      this.nowPages=data-0;
      this.allPages=this.setAll();
      this.$emit('getPage',this.nowPages);
    },
    setAll:function(){
      var all=this.allPage||1;
      if(all<=this.showMax){
        var arr=[];
        for(var i=0;i<all;i++){
          arr.push(i+1);
        };
      }else if(this.nowPages<4){
        var arr=[];
        for(var i=0;i<all;i++){
          if(i+1<=4){
            arr.push(i+1);
          }else if(i+1==5){
            arr.push('···');
          }else if(i+1==all){
            arr.push(i+1);
          };
        };
      }else{
        var arr=[1,'···'];
        if(this.nowPages>=all-2){
          arr.push(all-3);
          arr.push(all-2);
          arr.push(all-1);
          arr.push(all);
        }else{
          arr.push(this.nowPages-1);
          arr.push(this.nowPages);
          arr.push(this.nowPages+1);
          arr.push('···');
          arr.push(all);
        };
      };
      return arr;
    },
    prev:function(){
      this.nowPages=this.nowPages-1<=0?1:this.nowPages-1;
      this.setPage(this.nowPages-0);
    },
    next:function(){
      this.nowPages=this.nowPages+1>=this.allPage?this.allPage:this.nowPages+1;
      this.setPage(this.nowPages-0);
    },
    pageIn:function(){
      var reg=/\d+/;
      if(this.pageVal===''){
        return false;
      };
      var num=reg.exec(this.pageVal);
      if(num===null||num[0]-0===0){
        this.pageVal=1;
      }else if(num[0]-0>0&&num[0]-0<=this.allPage){
        this.pageVal=num[0]-0;
      }else if(num[0]-0>this.allPage){
        this.pageVal=this.allPage;
      };
    },
    pageBl:function(){
      var reg=/\d+/;
      if(this.pageVal===''){
        this.pageVal=1;
        return false;
      };
      var num=reg.exec(this.pageVal);
      if(num===null||num[0]-0===0){
        this.pageVal=1;
      }else if(num[0]-0>0&&num[0]-0<=this.allPage){
        this.pageVal=num[0]-0;
      }else if(num[0]-0>this.allPage){
        this.pageVal=this.allPage;
      };
    },
    jump:function(){
      this.setPage(this.pageVal-0);
    }
  },
  watch:{
    allPage:function(){
      this.nowPages=this.nowPage;
      this.allPages=this.setAll();
    }
  }
}
</script>
<style scoped>
  .fl{
    float:left;
  }
  .cle::after{
    content:'';
    height: 0;
    display: block;
    visibility: visible;
    clear: both;
  }
  .cle{
    zoom:1;
  }
  .page{
    width:auto;
    height:30px;
  }
  .page-num{
    width:30px;
    height:30px;
    text-align:center;
    line-height:30px;
    font-size:12px;
  }
  .page-num-in{
    width:100%;
    height:100%;
    outline:none;
    border:1px solid #000;
    background-color:transparent;
    box-sizing:border-box;
  }
  .page-now{
    color:#fff;
    background:#1F9DF1;
  }
  .page-prev{
    width:30px;
    height:30px;
    margin-right:20px;
  }
  .page-prev div{
    margin-top:10px;
    border:6px solid #000;
    border-top-color:transparent;
    border-left-color:transparent;
    border-bottom-color:transparent;
  }
  .page-next{
    width:30px;
    height:30px;
    margin-left:20px;
  }
  .page-next div{
    margin-top:10px;
    border:6px solid #000;
    border-top-color:transparent;
    border-right-color:transparent;
    border-bottom-color:transparent;
  }
  .page-btn{
    width:auto;
    height:30px;
    outline:none;
    border:1px solid #000;
    margin-left:20px;
    padding:0 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .point{
    cursor: pointer;
  }
</style>
<style scoped>
    @import '../assets/css/cloudPop.css';  
</style>





// WEBPACK FOOTER //
// src/components/Page.vue